import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const OrderSuccess = () => {
  const [params] = useSearchParams();
  const orderNumber = params.get('order');
  const productName = params.get('product');

  return (
    <div className="min-h-screen bg-offwhite pt-24 md:pt-28 pb-16">
      <div className="section-wide">
        <div className="max-w-md mx-auto text-center space-y-6">
          <div className="flex justify-center">
            <CheckCircleIcon className="w-20 h-20 text-green-500" />
          </div>

          <div>
            <h1 className="font-display text-display-sm text-offblack tracking-tight">
              Order Confirmed!
            </h1>
            <p className="text-warmgray-500 mt-2 text-sm">
              Your order has been placed successfully.
            </p>
          </div>

          {orderNumber && (
            <div className="bg-warmgray-100 border border-warmgray-200 px-6 py-4">
              <p className="text-xs uppercase tracking-widest text-warmgray-500 mb-1">Order Number</p>
              <p className="font-display text-2xl text-offblack">#{orderNumber}</p>
            </div>
          )}

          {productName && (
            <p className="text-sm text-warmgray-600">
              Your order for <strong className="text-offblack">{productName}</strong> has been received.
            </p>
          )}

          {/* Next steps */}
          <div className="bg-white border border-warmgray-200 px-6 py-5 text-left space-y-3">
            <p className="text-xs uppercase tracking-wider font-semibold text-offblack mb-3">
              What happens next
            </p>
            <ul className="text-sm text-warmgray-600 space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 rounded-full bg-offblack text-offwhite text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">1</span>
                <span>Our team will contact you shortly to confirm your order.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 rounded-full bg-offblack text-offwhite text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">2</span>
                <span>Delivery within <strong className="text-offblack">2–5 business days</strong> across Algeria.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 rounded-full bg-offblack text-offwhite text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">3</span>
                <span>Cash on Delivery — pay when you receive your order.</span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-3">
            <Link
              to="/collections"
              className="w-full bg-offblack text-offwhite py-4 text-sm font-semibold tracking-[0.12em] uppercase hover:bg-charcoal transition-colors text-center"
            >
              Continue Shopping
            </Link>
            <Link
              to="/"
              className="w-full border border-warmgray-300 text-offblack py-4 text-sm font-medium tracking-wider uppercase hover:border-offblack transition-colors text-center"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
